
import { Model } from 'backbone';

class AccountSettingsModel extends Model {

    initialize() {
    }

    defaults() {
        return {};
    }

    parse(response, options)  {
        return response;
    }
}

export default AccountSettingsModel;
